import "./src/styles.css";
import React from "react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";

import { FirebaseProvider } from "./src/hooks/useFirebase";
import { FirestoreProvider } from "./src/hooks/useFirestore";
import { AuthProvider } from "./src/hooks/useAuth";
import { UserProvider } from "./src/hooks/useUser";
import theme from "./src/theme";

export const wrapRootElement = ({ element }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <SnackbarProvider autoHideDuration={5000}>
        <FirebaseProvider>
          <FirestoreProvider>
            <AuthProvider>
              <UserProvider>{element}</UserProvider>
            </AuthProvider>
          </FirestoreProvider>
        </FirebaseProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);
